// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2w5gj","cell":"ColumnAccessor_cell__1TiB-","firstCellAccent":"ColumnAccessor_firstCellAccent__2HbgJ"};